import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-list-item-container", class: {
    "mp-list-item-active": this.attr("active"),
    "mp-list-item-static": this.attr("static"),
    "mp-list-item-disabled": this.attr("disabled")
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }));
}
